import React from "react";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import copperImage from "../Assets/Images/Range3.webp";
import copper1 from "../Assets/Images/Range2.jpg";
import copper2 from "../Assets/Images/copper02.jpeg";
import copper3 from "../Assets/Images/product13.jpg";
import copper4 from "../Assets/Images/product19.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const CopperLaminationFullTinned = () => {
  const navigate = useNavigate();

  const products = [
    {
      name: "Fusion Welded Copper Flexible",
      image: copper1,
    },
    {
      name: "Laminated Copper Flexible",
      image: copper2,
    },
    {
      name: "Press Welded Copper Connector",
      image: copper3,
    },
    {
      name: "Custom Flexible Copper Busbar",
      image: copper4,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Copper Lamination - Full Tinned | Delta Engineering</title>
        <meta
          name="description"
          content="High-quality tin plated copper laminated flexible connectors for power plants, switchgear, welding machines, and locomotives. Durable, low-resistance, and customizable for industrial applications."
        />
        <meta
          name="keywords"
          content="Copper Lamination Full Tinned, Tin Plated Copper Laminated Flexible Connectors, Silver Plated Copper Laminated Flexible Connectors, Laminated Copper Flexible, Copper Flexible Shunts, Copper Busbars, Expansion Joints"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Copper Lamination - Full Tinned" />
        <meta
          property="og:description"
          content="Advanced copper laminated flexible connectors manufactured using ETP grade copper foil. Tin or silver plated options available with excellent conductivity and durability."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/copper-lamination-full-tinned"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/copper-lamination-full-tinned.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Copper Lamination - Full Tinned" />
        <meta
          name="twitter:description"
          content="ETP grade copper laminated flexible connectors with tin plating. Ideal for power plants, bus ducts, switchgear, welding machines, and electric locomotives."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/copper-lamination-full-tinned.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text">copper-lamination-</span>{" "}
                <span className="white-text">full-tinned</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Advanced metal bonding solutions for high-performance electrical
                and mechanical applications.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <div
        className="copper-laminated-section py-5 bg-light pt-3"
        style={{ position: "relative" }}
      >
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Laminated Copper Flexible Connectors{" "}
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted text-center mb-5">
                Delta Engineering Metal Company is a reputed manufacturer,
                supplier, exporter, and distributor of copper laminated flexible
                connectors, shunts, jumpers, and busbars.
              </p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={4}>
              <Image
                src={copperImage}
                fluid
                rounded
                alt="Copper Laminated Connector"
              />
            </Col>
            <Col md={8}>
              <h5 className="fw-semibold">Plating Options:</h5>
              <ul className="text-muted ps-3">
                <li>Tin Plated Copper Laminated Flexible Connectors</li>
                <li>Silver Plated Copper Laminated Flexible Connectors</li>
              </ul>

              <h5 className="fw-semibold mt-4">Features:</h5>
              <ul className="text-muted ps-3">
                <li>Available in different sizes</li>
                <li>Easy Application</li>
                <li>Copper laminated flexible</li>
                <li>Fusion Welded Copper Flexible</li>
                <li>Laminated Copper Flexible</li>
                <li>Copper laminated flexible jumper</li>
                <li>Tinned Copper Laminated Flexible</li>
                <li>Copper laminated flexible shunt</li>
              </ul>
            </Col>
          </Row>

          <h2 className="text-center fw-bold mb-4">Related Products</h2>
          <Row className="g-4">
            {products.map((product, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="h-100 shadow-sm border-0 text-center">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{
                      height: "180px",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                  <Card.Body>
                    <Card.Title className="text-muted fs-6">
                      {product.name}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h4 className="fw-bold mt-5 mb-3">Description</h4>
          <p className="text-muted">
            Copper Laminated Flexible Connectors do the job of acting as
            flexible expansion joints for connecting bus bars in different
            applications. They are manufactured by using electrolytic tough
            pitch grade (ETP) copper foil. These multiple copper foils,
            generally of 0.2mm thickness, are stacked together and are then
            solidified by applying high current under high pressure.
          </p>
          <p className="text-muted">
            The solidification is done by a special metal diffusion process
            where the copper melts itself and forms a homogeneous bond. Due to
            this process, there is a very negligible, almost nil, millivolt drop
            across the connector, which results in a reduction in temperature
            rise and increase in the current carrying capacity.
          </p>
          <p className="text-muted">
            Copper laminated flexible connectors carry a constant cross-section
            area over the entire piece. Hence, the current carrying capacity of
            a solid copper busbar and that of a laminated copper flexible
            connector are the same. This makes laminated copper flexible, a
            perfect substitute for solid copper busbar. There is no filler metal
            used for solidifying the copper laminated flexible connector.
          </p>

          <h5 className="fw-semibold mt-4">Applications:</h5>
          <ul className="text-muted ps-3">
            <li>Power Plants</li>
            <li>Bus Ducts</li>
            <li>Caustic Soda Plants</li>
            <li>Resistance Welding Machines</li>
            <li>Electric Locomotives</li>
            <li>Switchgear</li>
          </ul>

          <h5 className="fw-semibold mt-4">Specifications:</h5>
          <ul className="text-muted ps-3">
            <li>Foil thickness: 0.05mm to 0.50mm</li>
            <li>Width: 20mm to 400mm</li>
            <li>Cross-section: 20 sq.mm to 10,000+ sq.mm</li>
            <li>Ends can be bare, tin or silver plated</li>
            <li>ETP grade copper (99.90%+, conductivity &gt; 97% IACS)</li>
            <li>Optional insulation available</li>
          </ul>

          <p className="text-muted mt-3">
            The ends can also be solidified using copper rivets. Solid areas
            support drilling, brazing, welding, milling, and more. We use LME
            grade “A” Copper Cathode with &gt;99.9% purity to ensure excellent
            conductivity and long life.
          </p>

          <h5 className="fw-semibold mt-4">Customization:</h5>
          <p className="text-muted">
            All connectors are fully tailored to customer specifications. Our
            skilled engineers work closely with you to recommend the right
            solution for your application, fostering long-standing partnerships
            with major companies in India and abroad.
          </p>
        </Container>
      </div>
    </>
  );
};

export default CopperLaminationFullTinned;
